import React, { useEffect, useState } from "react";
import { HiArrowUpRight } from "react-icons/hi2";
import api, { mediaUrl } from "../../lib/api";
import useReveal from "../../hooks/useReveal";
import useSEO from "../../seo/useSEO";
import { collectionPageSchema, breadcrumb } from "../../seo/schemas";

export default function Projects() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useReveal();

  useEffect(() => {
    let live = true;
    api.get("/api/projects")
      .then(({ data }) => { if (live) setItems(data.items || []); })
      .catch((e) => { if (live) setError(e?.response?.data?.error || e.message); })
      .finally(() => { if (live) setLoading(false); });
    return () => { live = false; };
  }, []);

  useSEO({
    title: "Projects — Selected Work by Oguzhan Ozcelik",
    description:
      "Selected case studies and live projects across Shopify, React and full-stack web — built by Oguzhan Ozcelik.",
    path: "/project",
    jsonLd: items.length ? {
      "@context": "https://schema.org",
      "@graph": [
        collectionPageSchema({
          name: "Projects — Oguzhan Ozcelik",
          description: "Selected case studies and live projects.",
          path: "/project",
          items: items.map((p) => ({ name: p.title, url: p.url, image: mediaUrl(p.image) })),
        }),
        breadcrumb([{ name: "Home", path: "/" }, { name: "Projects", path: "/project" }]),
      ],
    } : null,
    jsonLdId: "projects-jsonld",
  });

  return (
    <main>
      <section className="section section--hero">
        <div className="container-x reveal">
          <span className="eyebrow">Selected work</span>
          <h1 className="about-hero__title">
            <span className="stroke">Projects</span>
            <br />
            <span className="it text-accent">that ship.</span>
          </h1>
          <p className="lead" style={{ maxWidth: "60ch", marginTop: 24 }}>
            A non-exhaustive set of stores, apps and platforms I've built or
            led — for founders, agencies and product teams.
          </p>
        </div>
      </section>

      <section className="section section--tight">
        <div className="container-x">
          {loading && <p className="text-muted">Loading…</p>}
          {error && <p style={{ color: "var(--danger)" }}>Failed to load projects: {error}</p>}
          {!loading && !error && items.length === 0 && (
            <p className="text-muted">No projects yet.</p>
          )}
          <div className="work-grid">
            {items.map((p) => (
              <a
                key={p.id}
                className="work reveal"
                href={p.url}
                target="_blank"
                rel="noreferrer noopener"
                aria-label={`${p.title} — open site`}
              >
                <div className="work__media">
                  {p.category && (
                    <span className="work__badge"><span className="dot" /> {p.category}</span>
                  )}
                  <span className="work__arrow"><HiArrowUpRight /></span>
                  {p.image
                    ? <img src={mediaUrl(p.image)} alt={`${p.title} screenshot`} loading="lazy" />
                    : <div style={{ width: "100%", height: "100%", background: "var(--surface-2)" }} />}
                </div>
                <div className="work__body">
                  <span className="work__title">{p.title}</span>
                  <span className="work__cat">{p.role}</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
